export default __webpack_public_path__ + "static/media/google_orange.a2d197a9.svg";